import { Injectable } from '@angular/core';
import { Rest, RestService } from '@ralba/shared';
import {
  OnboardingRequestDto,
  SubmitOnboardingRequestInputDto,
} from '../dto';

@Injectable({ providedIn: 'root' })
export class PublicOnboardingHttpApiService {
  constructor(private rest: RestService) {}

  public getOnboarding(params: { Body: string; TenantId: number }) {
    const request: Rest.Request<null> = {
      method: 'GET',
      url: '/api/public/onboarding/get',
      params,
    };
    return this.rest.request<null, Rest.AbpResponse<OnboardingRequestDto>>(
      request
    );
  }

  /**
   * Returns the tenant-specific Formly definition (JSON-serialised
   * `FormlyFieldConfig[]`) that the candidate's public form appends after
   * the core fields. Each tenant stores its own definition via the manage
   * endpoint; the public side reads it anonymously, scoped by Body+TenantId.
   *
   * Backend returns the raw string (possibly null/empty) wrapped in the
   * standard AbpResponse envelope thanks to wrap-result middleware.
   */
  public getAdditionalForm(params: { Body: string; TenantId: number }) {
    const request: Rest.Request<null> = {
      method: 'GET',
      url: '/api/public/onboarding/get-additional-form',
      params,
    };
    return this.rest.request<null, Rest.AbpResponse<string>>(request);
  }

  public submitOnboarding(body: {
    body: SubmitOnboardingRequestInputDto;
    tenantId: number;
  }) {
    const request: Rest.Request<{
      body: SubmitOnboardingRequestInputDto;
      tenantId: number;
    }> = {
      method: 'POST',
      url: '/api/public/onboarding/submit',
      body,
    };
    return this.rest.request<
      { body: SubmitOnboardingRequestInputDto; tenantId: number },
      Rest.AbpResponse<OnboardingRequestDto>
    >(request);
  }
}
